// app/profile/page.tsx
"use client";

//component imports
import Profile from "@/components/profile/profile";

export default function ProfilePage() {
  return <Profile />;
}
